import { FC } from 'react'
import { Card, Heading } from '@instabox/consumer-web-ui'
import { FormattedMessage } from 'react-intl'
import { GetFaqsQuery, Unarray } from '@instabox/consumer-web-shared'

import FAQList from '../FAQList'

export interface SimilarFAQListProps {
  faqs: Unarray<GetFaqsQuery['faqs']>['similar_faqs']
}

const SimilarFAQList: FC<SimilarFAQListProps> = ({ faqs }) => {
  const similarFaqs = faqs.map(({ related_faqs_id }) => ({ ...related_faqs_id }))
  if (similarFaqs.length === 0) {
    return null
  }
  return (
    <Card size="sm">
      <Heading as="h6" fontSize="sm" className="mb-4">
        <FormattedMessage id="help.similar_questions" />
      </Heading>
      <FAQList
        faqs={faqs.map(({ related_faqs_id }) => ({ ...related_faqs_id }))}
        withTrim={false}
      />
    </Card>
  )
}

export default SimilarFAQList
